import { useState } from 'react';
import { svgs } from '../../assets/svgs';
import { RegisterForm } from './RegisterForm';
import { useGlobalState } from '../../hooks/useGlobalState';
import { useParams } from 'react-router-dom';
import { ACTIONS } from '../../state';
import { v4 as uuid } from 'uuid'


export const Ticket = ({ ticket }) => {
   const { type } = useParams()
   const { discount, tickets, dispatch } = useGlobalState()
   const [isShowMore, setIsShowMore] = useState(false)
   // const [isModalOpen, setIsModalOpen] = useState(false)
   // const [isLoading, setIsLoading] = useState(false)

   const handelClick = (ticket) => {
      dispatch({ type: ACTIONS.SET_MODAL_STATUS, payload: { modal: 'registerForm', status: true } })
      for (let i = 0; i < ticket.increment_by; i++) {
         dispatch({ type: ACTIONS.ADD_TICKET, payload: { id: uuid(), type_id: ticket.id, ticket, addOns: [] } })
      }
   }

   return (
      <div className={`ticket ${ticket.name}`}>
         <div>
            <section>
               {svgs.ticketTop}
            </section>
            <header>
               <h2>{ticket.category_name} {ticket.category_name.toLowerCase().includes('general') ? '' : 'Pass'}</h2>
               <h1>Ticket Type</h1>
               <h2>{ticket.name}</h2>
               <h3><sup>$</sup>{ticket.cost - discount}</h3>
               {discount > 0 && <h4><sup>$</sup>{ticket.cost}</h4>}
               <h5 style={{ visibility: ticket.name.toLowerCase().includes('platinum') ? 'visible' : 'hidden' }}>Includes 3 Tickets</h5>
               <button onClick={() => handelClick(ticket)}>{svgs.ticketButton}<span>book now</span></button>
            </header>
            <section>
               {svgs.ticketMiddle}
            </section>
            <main>
               <div dangerouslySetInnerHTML={{ __html: ticket.description }}></div>
               <button onClick={() => setIsShowMore(!isShowMore)} className={isShowMore ? 'show-more open' : 'show-more'}>
                  <p>Show Benefits</p>
                  {svgs.arrowDown}
               </button>
               <ul className={isShowMore ? 'list open' : 'list'}>
                  {
                     ticket.benefits.map((benefit, index) =>
                        <li key={index}>{tickets.find(t => t.name === type).benefits.find(t => t.id === benefit)?.name.replaceAll('*', '\n*')}</li>
                     )
                  }
               </ul>
            </main>
            <section className={isShowMore ? '' : 'hide'}>
               {svgs.ticketBottom}
            </section>
         </div>
      </div>
   )
}

